import { useDialog } from "../Dialogs/DialogProvider";
import { Button, DialogContent } from "@material-ui/core";
import React from "react";
import EditCheckbox from "../EditArticle/EditCheckbox";
import ExcelExport from "./ExcelExport";
import { parse } from "date-fns";

const defaultColumns = [
  {
    key: "order date",
    selected: true,
    value: (row) => parse(row.created_at + "Z", "yyyy-MM-dd HH:mm:ssX", new Date()).toLocaleString(),
  },
  { key: "email", selected: true, value: (row) => row.email },
  { key: "name", selected: true, value: (row) => row.contactInfo.name },
  { key: "business name", selected: true, value: (row) => row.contactInfo.businessName },
  { key: "order number", selected: true, value: (row) => row.id + "-T" + row.number },
  { key: "payment method", selected: true, value: (row) => row.payment_method },
  {
    key: "Total excl. Vat",
    selected: true,
    value: (row) => row.totalExVat / 100,
  },
  {
    key: "Total inc. Vat",
    selected: true,
    value: (row) => row.totalIncVat / 100,
  },
  {
    key: "address",
    selected: true,
    value: (row) => (row.contact_information != null ? JSON.parse(row.contact_information).address : ""),
  },
  {
    key: "city",
    selected: true,
    value: (row) => (row.contact_information != null ? JSON.parse(row.contact_information).city : ""),
  },
  {
    key: "postalCode",
    selected: true,
    value: (row) => (row.contact_information != null ? JSON.parse(row.contact_information).postalCode : ""),
  },
];

function RowExport(props) {
  const [openDialog, closeDialog] = useDialog();

  const uniqueVats = props.rows
    .reduce((uniqueVats, row) => {
      row.extra_delivery_costs_vat = Number.parseFloat(row.extra_delivery_costs_vat);
      row.extra_payment_costs_vat = Number.parseFloat(row.extra_payment_costs_vat);
      Object.keys(row.vats).forEach((vat) => {
        vat = Number.parseFloat(vat);
        if (!uniqueVats.includes(vat) && row.vats[vat] > 0) {
          uniqueVats.push(vat);
        }
      });
      if (!uniqueVats.includes(row.extra_delivery_costs_vat) && row.extra_delivery_costs > 0) {
        uniqueVats.push(row.extra_delivery_costs_vat);
      }
      if (!uniqueVats.includes(row.extra_payment_costs_vat) && row.extra_payment_costs > 0) {
        uniqueVats.push(row.extra_payment_costs_vat);
      }
      return uniqueVats;
    }, [])
    .sort();

  const vatColumns = uniqueVats.map((vat) => ({
    key: vat * 100 + " % vat",
    selected: true,
    value: (row) => {
      return row.totalVats[vat] / 100.0;
    },
  }));

  const [columns, setColumns] = React.useState([...defaultColumns, ...vatColumns]);

  return (
    <>
      <DialogContent>
        <div style={{ display: "flex", flexFlow: "wrap" }}>
          {columns.map((column) => {
            return (
              <EditCheckbox
                key={column.key}
                value={column.selected}
                label={column.key}
                onChange={() => {
                  column.selected = !column.selected;
                  setColumns([...defaultColumns]);
                }}
              />
            );
          })}
        </div>
        <Button
          onClick={() => {
            openDialog({
              children: (
                <ExcelExport
                  data={props.rows.map((row) => {
                    return columns
                      .filter((column) => column.selected)
                      .map((column) => ({ [column.key]: column.value(row) }))
                      .reduce((obj, newObj) => ({ ...obj, ...newObj }), {});
                  })}
                  columns={columns
                    .filter((column) => column.selected)
                    .map((column) => {
                      column.label = column.key;
                      return column;
                    })}
                />
              ),
            });
            setTimeout(() => {
              closeDialog();
            }, 300);
          }}
        >
          Download Excel
        </Button>
      </DialogContent>
    </>
  );
}

export default RowExport;
